export default __webpack_public_path__ + "static/media/avatar.6d931bbb.svg";